import type React from 'react';

import { Text } from '@change/ds-core-ui';

import { TranslateHtml, useI18n, withI18nPlaceholders } from '@change-corgi/core-react/i18n';

import I18N_PLACEHOLDERS from '#config/i18n/placeholders/petitionDetails/petition-details.yml';

const CHANGE_AMBASSADORS_TERMS_URL = '/ambassadors/terms';

type Props = {
	starterName: string;
};

const ChangeAmbassadorDisclosureComponent: React.FC<Props> = ({ starterName }) => {
	const { translate } = useI18n();

	return (
		<Text as="p" size="small" className="text-typography-weak mt-4">
			<TranslateHtml
				value="corgi.petition_details.change_ambassador_disclosure.text"
				replacements={{
					name: starterName,
					link: (
						<a
							data-qa="change-ambassador-disclosure-link"
							href={CHANGE_AMBASSADORS_TERMS_URL}
							target="_blank"
							rel="noopener noreferrer"
							aria-label={translate('corgi.petition_details.change_ambassador_disclosure.link_aria_label')}
						>
							{translate('corgi.petition_details.change_ambassador_disclosure.link_text')}
						</a>
					),
				}}
			/>
		</Text>
	);
};

export const ChangeAmbassadorDisclosure = withI18nPlaceholders(I18N_PLACEHOLDERS, ChangeAmbassadorDisclosureComponent);
